module.exports = __webpack_public_path__ + "assets/bd4e63b77f2edf45db1738d6c6ed3e9b.png";